import apiClient from './apiClient';
import { ENDPOINTS } from '../constants/api';

/**
 * Event Service
 * Communicates with the backend /api/v1/events controller.
 * Enforced by Bearer token added automatically by apiClient request interceptor.
 */

/**
 * Fetch all events (admin / user authorized).
 * @returns {Promise<object[]>} List of events
 */
export async function getAllEvents() {
  const { data: response } = await apiClient.get(ENDPOINTS.events.all);
  // Backend returns ApiResponse: { status, message, data: [...] }
  return response?.data || [];
}

/**
 * Create a new event.
 * @param {{ title: string }} dto
 * @returns {Promise<object>} Created event data
 */
export async function addEvent(dto) {
  const { data: response } = await apiClient.post(ENDPOINTS.events.add, dto);
  return response?.data;
}

/**
 * Update an existing event.
 * @param {number|string} id
 * @param {{ title: string }} dto
 * @returns {Promise<object>} Updated event data
 */
export async function updateEvent(id, dto) {
  const { data: response } = await apiClient.put(ENDPOINTS.events.update(id), dto);
  return response?.data;
}

/**
 * Delete an event by ID.
 * @param {number|string} id
 * @returns {Promise<boolean>} Success status
 */
export async function deleteEvent(id) {
  await apiClient.delete(ENDPOINTS.events.delete(id));
  return true;
}
